export default __webpack_public_path__ + "static/media/spinner.a74450aa.gif";